/**
 * 项目所有接口配置
 * {
        name: "userinfo", // 接口名 调用的时候就是调用接口名 this.$api['userinfo']
        method: "GET",  // 请求方式
        desc: "测试服务处",  // 接口描述
        path: "/tomato/common/showAllGroup", // 请求路径
        serveType: 'api', // 'api', 'parent', 'nginx', 'mqc' // 默认 'api'
        mockEnable: false, // 单独控制这个接口是否请求mock路径
        mockPath: "/api/userinfo", // 请求虚拟数据的路径
        params: { // 默认参数
            a: 1,
            b: 2
        }
        loading: "0" // 默认"1"展示
    }
 */

import common from './common'
import app from './app' // APP消息推送相关
import user from './user'
import city from './city'// 机场  城市  站点 数据
import emp from './emp'// 员工 联系人 编辑 新增 删除
import bx from './bx' //保险
import approval from './approval' //审批
import baidu from './baidu' //与百度相关的接口

import tkQuery from './tk/tkQuery' //机票查询预订流程
import tkIntQuery from './tkInt/tkIntQuery' //机票查询预订流程
import tkOrder from './tk/tkOrder' //机票订单
import tkIntOrder from './tkInt/tkIntOrder' //机票订单
import tkStrategy from './tk/tkStrategy' //机场攻略
import carQuery from './car/carQuery' //用车
import carOrder from './car/carOrder' //用车订单
import htQuery from './ht/htQuery'
import htQueryInt from './ht/htQueryInt'
import trQuery from './tr/trQuery' // 火车票
import trOrder from './tr/trOrder' // 火车票
import VisaQuery from './Visa/VisaQuery' // 签证
import VisaOrder from './Visa/VisaOrder' // 签证

import airService from './airService' //  优先值机// 要客通// 休息室 // 快速安检
import btlh from './btlh' // 包头联航
import statistical from './statistical'
import coupon from './coupon/coupon' // 优惠券

export default {
  common,
  app,
  user,
  city,
  emp,
  bx,
  approval,
  baidu,
  tkQuery,
  tkIntQuery,
  tkOrder,
  tkIntOrder,
  tkStrategy,
  carQuery,
  carOrder,
  htQuery,
  htQueryInt,
  trQuery,
  trOrder,
  VisaQuery,
  VisaOrder,
  airService,
  btlh,
  statistical,
  coupon
}
